import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

import { BaseSchema } from '../baseSchema';

import { Places } from './places';
import { Montgolfieres } from '../montgolfieres/montgolfieres';
import { Users } from '../users/users';
import { Reservations } from '../reservations/reservations';

import moment from 'moment';

export const Flights = new Mongo.Collection('flights');

Flights.attachRoles('flights');

export const FlightSchema = new SimpleSchema([{
    date: {
        type: Date,
        label: "Date du vol"
    },
    period: {
        type: String,
        label: "Periode du vol"
    },
    place: {
        type: String,
        label: "Lieu du vol"
    },
	placeId: {
		type: String,
		label: "Lieu d'envol",
		optional: true
	},
    pilotId: {
        type: String,
		label: "Pilote",
		optional: true
    },
    montgolfiereId: {
        type: String,
		label: "Montgolfiere",
		optional: true
    },
    reservationIds: {
        type: [String],
        label: "Reservations",
        optional: true
    },
    status: {
        type: String,
		label: "Etat du vol",
		allowedValues: ["preparing", "prepared", "cancelled", "validated"]	
    },
	meetingDate: {
		type: Date,
		label: "Heure de rendez-vous",
		optional: true
	},
    takeOffDate: {
        type: Date,
		label: "Heure de début",
		optional: true
    },
    landingDate: {
        type: Date,
        label: "Heure de fin",
		optional: true
	},
    takeOffPlace: {
        type: String,
		label: "Lieu de décollage",
		optional: true
    },
    landingPlace: {
        type: String,
        label: "Lieu d'atterrissage",
		optional: true
	},
	time: {
		type: Number,
		label: "Temps de vol",
		optional: true,
		autoValue: function() {
			if(this.field("takeOffDate").value && this.field("landingDate").value)
				return moment(this.field("landingDate").value).diff(moment(this.field("takeOffDate").value), 'minutes');
			else 
				this.field("time").value;
		}
	},
	temp: {
		type: Number,
		optional: true
	},
	validToFlight: {
		type: Boolean,
		defaultValue: false
	}
}, BaseSchema]);

Flights.attachSchema(FlightSchema);

Meteor.methods({
	'flights.insert'(attributes) {
		Flights.insert(attributes); 
	}
});


Flights.helpers({
    getPilote: function() {
        return Meteor.users.findOne({_id: this.pilotId});
    },
    getMontgolfiere: function() {
        return Montgolfieres.findOne({_id: this.montgolfiereId});
    },
    getReservations: function() {
    	if (!this.reservationIds)
    		return [];
        return this.reservationIds.map((reservationId) => {
            return Reservations.findOne({_id: reservationId});
        });
    },
    getDisplayDate: function() {
        return moment(this.date).format('DD/MM/YYYY');
    },
    getSeats: function() {
        let seats = this.getMontgolfiere().maxPassengers;
        _.each(this.getReservations(), (reservation) => {
            seats = seats - reservation.passengers.length;
        });
        return seats;
    },
	getPeriod: function() {
		if (this.period == "morning")
			return "Matin";
		else
			return "Soir";
	},
	getStatus: function() {
		if(this.status == 'preparing')
			return "En préparation";
		if(this.status == 'prepared')
			return "Validé";
		if(this.status == 'cancelled')
			return "Annulé";
		if(this.status == 'pending')
			return "En attente";
		if(this.status = 'validated')
			return "Clôturé";
	},
    getPlace: function() {
        if(this.place == 'anjou')
            return "Sites d'envol Montgolfieres d'Anjou";
        else
            return "Sites d'envol Nantes Montgolfieres";
    },
    getPlaceCode: function() {
        if(this.place == 'anjou')
            return "[A]";
        else
            return "[N]";
    },
	getMeetPoint: function() {
		return Places.findOne(this.placeId);
	},
    removeReservation: function(_id) {
        let reservations = _.without(this.reservations, _id);
        Flights.update(this._id, {$set: {reservations:reservations}});
    }
}); 



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights/flights.js
 **/